module.exports = __webpack_public_path__ + "static/media/177-envelope-mail-send-outline.6641c7da.gif";